import axiosClient from "../../../../../../system/helpers/axiosConfig";

export const getCountriesList = (api) => {
  return axiosClient.get(api).then((r) => r.data);
};
export const getAffiliateGeoDetails = (api, params) => {
  return axiosClient.post(api, { ...params }).then((r) => r.data);
};
